import {takeEvery} from "redux-saga/effects"
import * as sagaTypes from './../types';

function* rootSaga() {
    // yield takeEvery(sagaTypes.LOGIN_USER_SAGA, loginUserSaga);
    // yield takeEvery(sagaTypes.LOGIN_USER_STAFF_SAGA, loginUserStaffSaga);
    // yield takeEvery(sagaTypes.SET_TIMER_LOGIN_SAGA, startTimerSaga);

    // yield takeEvery(sagaTypes.ACTIVE_USER_SAGA, activeUserSaga);
    // yield takeEvery(sagaTypes.RESEND_CODE_SAGA, resendCodeSaga);
}

export default rootSaga;